export const getSubmittedFormDataSuccess = (payload) => {
  return {
    type: "GET_SUBMIITED_FORM_DATA_SUCCESS",
    payload
  };
}

export const getSubmittedFormDataFail = (payload) => {
  return {
    type: "GET_SUBMIITED_FORM_DATA_FAIL",
  };
}

export const getAllUsers = () => {
  return {
    type: "GET_ALL_USERS",
  };
}

export const getAllUsersSuccess = (data) => {
  return {
    type: "GET_ALL_USERS_SUCCESS",
    data
  };
}